import { canAccessNativeLeLens } from '~/utils/canAccessLeLens';

/** Native report viewing follows the signed-in Lens pilot gate; management stays role gated. */
export function isProductPerformanceEnabled(user: { roles?: Array<string>; email?: string | null } | null | undefined): boolean {
  return canAccessNativeLeLens(user);
}
